<script>
    import { fade } from "svelte/transition";

    import {
        getMbsItemNumLabel,
        updateModifierItems,
    } from "../../../helpers/mbsHelper.svelte";

    export let itemProps = {},
        defaultItems = [],
        selectedItems = [],
        updateItems = () => {};

    $: isCardiacEncounter = itemProps.billingType == 3;

    $: if (defaultItems.length) _syncModifierItems();

    let modifierItems = [];

    const specialModifierItemCodes = [25013, 25014];

    const handleSelectItem = (item) => {
        updateItems(updateModifierItems(item, selectedItems));
    };

    const handleSelectAgeModifierItem = (item) => {
        //allow removing only if patient age is between 4 and 75
        if(itemProps.patientAge >=4 && itemProps.patientAge <= 75) {
            var ageItem = defaultItems.find((i) => i.itemNum == item);
            updateItems(updateModifierItems(ageItem, selectedItems));
        }
    };

    // HELPER FUNCTIONS
    const _syncModifierItems = () => {
        const asaItems = [];
        const emergencyItems = [];

        defaultItems.map((item) => {
            if (item.infoRegion == "ASA") asaItems.push(item);
            else if (
                item.infoRegion == "Emergency" &&
                (item.itemNum == 25020 || item.itemNum == 25025)
            )
                emergencyItems.push(item);
        });

        modifierItems = [...asaItems, ...emergencyItems];
    };
</script>

<div
    class="flex flex-col gap-y-2 border-2 rounded-md justify-center p-4"
    transition:fade={{ duration: isCardiacEncounter ? 100 : 0 }}
>
    <div class="flex flex-1 items-center">
        <p class="w-auto min-w-[6rem] font-bold text-lg">Modifiers</p>
    </div>

    <div class="flex flex-wrap gap-4 w-full">
        {#each modifierItems.filter(({ itemNum }) => itemNum != 25020 && itemNum != 25025) as item}
            <button
                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                    selectedItems.some((itm) => itm.id == item.id)
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                on:click|preventDefault={() => handleSelectItem(item)}
            >
                {getMbsItemNumLabel(item)}
                {item.infoShortTitle}
            </button>
        {/each}
    </div>

    <div class="flex flex-wrap gap-4 w-full">
        {#each modifierItems.filter(({ itemNum }) => itemNum == 25020 || itemNum == 25025) as item}
            <button
                class={`btn btn-sm rounded rounded-full text-xs hover:btn-primary ${
                    selectedItems.some((itm) => itm.id == item.id)
                        ? "btn-primary"
                        : "btn-secondary"
                }`}
                on:click|preventDefault={() => handleSelectItem(item)}
            >
                {item.itemNum} - {item.itemNum == 25020
                    ? "In hours Emergency"
                    : "Out of hours Emergency"}
            </button>
        {/each}
    </div>

    <p class="text-md text-secondary">Age Modifier</p>

    <div class="flex flex-wrap gap-4 w-full">
        <button
            class="btn btn-primary btn-sm rounded rounded-full text-xs"
            disabled={!selectedItems.some(
                (item) => item.itemNum == specialModifierItemCodes[0],
            )}
            on:click|preventDefault={() => handleSelectAgeModifierItem(specialModifierItemCodes[0])}
        >
            {specialModifierItemCodes[0]} - {"Age < 4"}
        </button>

        <button
            class="btn btn-primary btn-sm rounded rounded-full text-xs"
            disabled={!selectedItems.some(
                (item) => item.itemNum == specialModifierItemCodes[1],
            )}

            on:click|preventDefault={() => handleSelectAgeModifierItem(specialModifierItemCodes[1])}
        >
            {specialModifierItemCodes[1]} - {"Age > 75"}
        </button>
    </div>
</div>
